module.exports = __webpack_public_path__ + "img/apex-ui-logo.6aba7046.png";